import { Result, PageError, Env } from "core/utils";
export function processResult(appState, slug, result, refetch) {
    if (Result.isLoading(result)) {
        return processLoading(appState);
    }
    if (Result.isFail(result)) {
        return processFail(result.value, slug, refetch);
    }
    return result;
}
var container = { firstClientSideRender: true };
/**
 * CSR: Server error & first pass
 * This avoids the flashing loading screen on first visit
 */
function processLoading(appState) {
    if (Env.isClient &&
        appState.pageError !== null &&
        container.firstClientSideRender) {
        container.firstClientSideRender = false;
        return Result.fail(appState.pageError);
    }
    return Result.loading;
}
/**
 * Query result is fail -> internalServerError
 */
function processFail(errorMessage, slug, refetch) {
    var refetchCallback = function (event) {
        event.preventDefault();
        refetch();
    };
    return Result.fail(PageError.internalServerError("Page data fetching failed. ".concat(errorMessage), slug, Env.isClient ? refetchCallback : undefined));
}
